'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Creates an array of elements split into groups the length of size.
 * If array can't be split evenly, the final chunk will be the remaining elements.
 *
 * https://youmightnotneed.com/lodash#chunk
 *
 * @param arr T[]
 * @param chunkSize number
 * @param cache T[][]
 * @returns T[][]
 */ const chunk = (arr, chunkSize = 1, cache = [])=>{
    const tmp = [
        ...arr
    ];
    if (chunkSize <= 0) return cache;
    while(tmp.length > 0)cache.push(tmp.splice(0, chunkSize));
    return cache;
};

exports.chunk = chunk;
//# sourceMappingURL=array.js.map
